<button ion-button
        clear
        color="primary-blue"
        [disabled]="isInitializing"
        (click)="addList($event)"
        icon-end>
        ADD TO LIST
        <ion-spinner *ngIf="isInitializing" class="add-to-list-button--spinner"></ion-spinner>
</button>

